<template>
	<div :class="['integration-card', 'is-' + thirdPartyState.class]">
		<div class="integration-card__container">
			<div
				class="integration-card__status"
				:title="thirdPartyState.title + 'Vendor'"
			>
				<i :class="['icon', 'icon-' + thirdPartyState.icon]"></i>
			</div>
			<div class="integration-card__main">
				<span class="integration-card__name">
					{{ source.dcsIntegration }}
				</span>
				<span class="integration-card__integration">
					{{ source.dcsParty }}
				</span>
				<span class="integration-card__partyId">
					{{ source.partyId }}
				</span>
			</div>
		</div>
		<ActionsSet
			class="integration-card__actions"
			:id="`${uid}_action`"
			:variant="variant"
			:options="actions"
		/>
	</div>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';
import ValidatePermissions from '@/sections/integration/validate-permission-mixins';

export default {
	name: 'ThirdPartyCard',
	inheritAttrs: false,
	mixins: [ValidatePermissions],
	props: {
		source: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		ActionsSet
	},
	computed: {
		thirdPartyState() {
			if (!this.source.active) {
				return {
					class: 'inactive',
					icon: 'check-indeterminate',
					title: 'Inactive'
				};
			} else {
				return {
					class: 'active',
					icon: 'checkbox',
					title: 'Active'
				};
			}
		},
		actions() {
			return [
				{
					id: 1,
					action: this.edit,
					title: 'Select to go to integration settings',
					iconClass: 'icon icon-manage',
					label: 'Settings',
					type: 'anchor',
					visible: true,
					disabled: !this.canUpdate
				},
				{
					id: 2,
					action: this.goToIntegrationsPage,
					title: 'Select to go to integrations page',
					iconClass: 'icon icon-company',
					label: 'Integrations',
					type: 'anchor',
					visible: true
				},
				{
					id: 3,
					action: this.showTransactions,
					iconClass: 'icon icon-transaction',
					label: 'Transactions',
					title: 'Select to go to integration transactions',
					type: 'anchor',
					visible: true
				},
				{
					id: 4,
					action: '#',
					iconClass: 'icon icon-history',
					label: 'History',
					title: 'Select to go to integration history',
					type: 'anchor',
					visible: false,
					disabled: true
				}
			];
		},
		hasCustomers() {
			return this.source.customers && this.source.customers.length > 0;
		}
	},
	methods: {
		edit() {
			this.$emit('editThirdParty', this.source.thirdPartyId);
		},
		goToIntegrationsPage() {
			this.$store.commit('integrations/setThirdParty', {
				...this.source
			});
			this.$router.push({
				path: `/integrations/thirdparties/${this.source.thirdPartyId}/integrations`
			});
		},
		showTransactions() {
			this.$store.commit('integrations/setThirdParty', {
				...this.source
			});
			this.$router.push({
				path: `/integrations/thirdparties/${this.source.partyId}/transactions`
			});
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Results Card
	* Can use SCSS variables = TRUE
	* [Table of Contents]
    *
    * BASE
    * BASE DESKTOP
 */

/*------------------------------------*\
  #BASE
\*------------------------------------*/
@import '@/scss/5-objects/_cards.scss';

.integration-card {
	@include card;
	display: grid;
	@include mq($until: md) {
		grid-template-rows: auto;
		row-gap: $gutter-lg;
	}

	&__container {
		display: flex;
	}
	&__main {
		font-weight: $medium-font-weight;
		font-size: $default-font-size;
	}

	&.is-inactive {
		.integration-card__status {
			@include text-contrast($neutral-3, $white, $black);
			background: $neutral-3;
		}
	}

	&__status {
		color: $white;
		margin-right: $gutter-lg;
		@include create-circle(16px, 16px, $ui-positive);
		@include vertical-horizontal-center-with-flex;
	}

	&__name,
	&__integration {
		display: block;
	}

	&__integration {
		font-size: $default-font-size - 2;
		font-weight: $default-font-weight;
	}
}

/*------------------------------------*\
  #BASE TABLET-UP
\*------------------------------------*/
@include mq($from: md) {
	.integration-card {
		column-gap: $gutter-lg;
		grid-template-columns: auto 1fr;
	}
}
</style>
